/**
 * @fileoverview PUT handler for the "/companies/:company_id/notification_preferences/update" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdNotificationPreferencesUpdateCacheKeys } from "./constants";
import type {
  CompaniesCompanyIdNotificationPreferencesUpdateResult,
  PutCompaniesCompanyIdNotificationPreferencesUpdateProps,
} from "./types";

export const putCompaniesCompanyIdNotificationPreferencesUpdate = reactQueryMutationAdapter(
  companiesCompanyIdNotificationPreferencesUpdateCacheKeys,
  (
    props: PutCompaniesCompanyIdNotificationPreferencesUpdateProps
  ): Promise<CompaniesCompanyIdNotificationPreferencesUpdateResult> => {
    return fetch(`/companies/${props.company_id}/notification_preferences/update`, "PUT", props);
  }
);
